import { render, staticRenderFns } from "./ElementStudioAttributes.vue?vue&type=template&id=fd985b04&"
import script from "./ElementStudioAttributes.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioAttributes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports